import type { PromocodesStore } from './interfaces'

export const actions = {
  setLoading (this: PromocodesStore, payload: PromocodesStore['loading']): void {
    this.loading = payload
  },
  setSaving (this: PromocodesStore, payload: PromocodesStore['saving']): void {
    this.saving = payload
  },
  setPromocodes (this: PromocodesStore, payload: PromocodesStore['promocodes']): void {
    this.promocodes = payload
  },
  setMeta (this: PromocodesStore, payload: PromocodesStore['meta']): void {
    this.meta = payload
  },
  setDiscounts (this: PromocodesStore, payload: PromocodesStore['discounts']): void {
    this.discounts = payload
  },
  setFilterSearch (this: PromocodesStore, payload: PromocodesStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterStatus (this: PromocodesStore, payload: PromocodesStore['filterStatus']): void {
    this.filterStatus = payload
  },
  setFilterDiscount (this: PromocodesStore, payload: PromocodesStore['filterDiscount']): void {
    this.filterDiscount = payload
  },
  setFilterFrom (this: PromocodesStore, payload: PromocodesStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: PromocodesStore, payload: PromocodesStore['filterTo']): void {
    this.filterTo = payload
  },
  setCurrentPage (this: PromocodesStore, payload: PromocodesStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: PromocodesStore, payload: PromocodesStore['perPage']): void {
    this.perPage = payload
  },
  setModalCreate (this: PromocodesStore, payload: PromocodesStore['isModalCreate']): void {
    this.isModalCreate = payload
  },
  setPromocodeToEdit (this: PromocodesStore, payload: PromocodesStore['promocodeToEdit']): void {
    this.promocodeToEdit = payload
  },
  resetFilters (this: PromocodesStore): void {
    this.filterSearch = null
    this.filterStatus = null
    this.filterDiscount = null
    this.filterFrom = null
    this.filterTo = null
    this.currentPage = 1
  },
}
